module.exports = __webpack_public_path__ + "static/media/heatingInstructions250120-2.489fcb03.jpg";